// FIXME: eslint error
/* eslint-disable no-restricted-syntax */
const emailRegex = /^(([^<>()[\]\\.'~^,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default function isEmail(value) {
  return emailRegex.test(value)
}
